// routes.js
import { Routes, Route } from "react-router-dom";
import HomePage from "../views/HomePage";
import AssetOfferLandingPage from "../views/AssetOfferLandingPage";
import ParticipantsDashboard from "../views/participants/ParticipantsDashboard";
import LdsMap from "../views/participants/LdsMap";
import CookiePolicyPage from "../views/CookiePolicyPage";

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/list-of-participants" element={<ParticipantsDashboard />} />
      <Route path="/view-offer/:id" element={<AssetOfferLandingPage />} />
      <Route path="/cookie-policy" element={<CookiePolicyPage />} />
      <Route path="/view-map" element={<LdsMap/>}/>
    </Routes>
  );
}
